import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { DepartmentReportStatusSummary } from "@features/report/tag/types/departmentReportStatusSummary";
import DepartmentReportStatusCountBreakdown from "@features/report/tag/components/DepartmentReportStatusCountBreakdown";
import { buildSoftConfirmMessages } from "@features/report/tag/utils/departmentReportStatusCounts";

const CloseTagConfirmModal: React.FC<{
    show: boolean;
    onHide: () => void;
    onConfirm: () => void;
    busy?: boolean;
    tagName?: string | null;
    summary: DepartmentReportStatusSummary | null;
}> = ({ show, onHide, onConfirm, busy = false, tagName, summary }) => {
    const messages = summary ? buildSoftConfirmMessages(summary) : null;

    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            centered
            size="lg"
        >
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-semibold">Close Reporting Period</Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-3">
                {tagName && (
                    <p>
                        Close report tag <strong>{tagName}</strong>?
                    </p>
                )}
                {messages && summary && (
                    <>
                        <p>{messages.intro}</p>
                        <p>{messages.leftover}</p>
                        <DepartmentReportStatusCountBreakdown
                            summary={summary}
                            mode="soft"
                            combinedLine={messages.progress}
                        />
                    </>
                )}
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0">
                <Button variant="outline-secondary" onClick={onHide} disabled={busy}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    size="lg"
                    className="btn-action"
                    onClick={onConfirm}
                    disabled={busy}
                    aria-busy={busy}
                >
                    {busy ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Closing...
                        </>
                    ) : (
                        "Close Period"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CloseTagConfirmModal;
